import React from 'react'

const Terms_conditions = () => {
  return (
    <div className="container my-5">
      <div className="card shadow border-0 p-4">
        <h2 className="text-center mb-4 fw-bold text-primary">
          Terms & Conditions
        </h2>

        <p className="text-muted mb-4">
          Welcome to <strong>Dartex Technology Private Limited</strong> (Dartex,
          “we”, “our”, or “us”). By signing up and using our platform, you (“Seller”,
          “you”, or “your”) agree to the following Terms & Conditions. Please read them
          carefully before using our services.
        </p>

        <section className="mb-4">
          <h5 className="fw-semibold">1. About Dartex</h5>
          <p className="mt-2">
          Dartex is a shipping aggregator platform that connects sellers with multiple
            courier partners. We provide technology, courier integration, and payment
            settlement services. We do not own courier companies, nor do we manufacture,
            check, or verify the contents of any parcel.
          </p>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">2. Use of Services</h5>
          <ul className="mt-2">
            <li>You must register with valid business and KYC details.</li>
            <li>
              You are responsible for the accuracy of recipient addresses, product details,
              and declarations.
            </li>
            <li>
              You agree not to ship prohibited, illegal, or restricted items as per courier
              and government laws.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">3. Shipping & Liability</h5>
          <ul className="mt-2">
            <li>
            Dartex does not open or verify parcels. The Seller is fully responsible for
              the goods shipped.
            </li>
            <li>
              Any disputes related to product quality, quantity, or authenticity are solely
              between the Seller and their buyer.
            </li>
            <li>
            Dartex and its courier partners will not be liable for damages, losses, or
              disputes arising from parcel contents.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">4. COD Remittance</h5>
          <ul className="mt-2">
            <li>Standard COD remittance cycle is Delivery Date + 7 Days (free of cost).</li>
            <li>
              Early COD Remittance is available on request and is chargeable as per the
              Seller’s plan.
            </li>
            <li>
            Dartex reserves the right to hold or delay remittance in cases of suspected
              fraud, chargebacks, or disputes.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">5. Payments & Charges</h5>
          <ul className="mt-2">
            <li>Shipping charges are deducted as per your plan and courier rates.</li>
            <li>
              Early COD charges, RTO (Return to Origin), weight discrepancies, or penalties
              from courier partners will be adjusted from the Seller’s account.
            </li>
            <li>
            Dartex reserves the right to revise charges with prior notice.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">6. Blacklisting & Penalties</h5>
          <p className="mt-2">
          Dartex may impose penalties, suspend, or permanently blacklist a Seller if:
          </p>
          <ul>
            <li>Fake or fraudulent COD orders are detected.</li>
            <li>Prohibited or illegal items are shipped.</li>
            <li>False claims or misuse of the platform occur.</li>
            <li>Payment defaults or chargebacks are raised against the Seller.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">7. Indemnity</h5>
          <p className="mt-2">
            You agree to indemnify and hold Dartex harmless against any claims, legal
            disputes, losses, or damages caused due to the goods shipped by you or misuse of
            the platform.
          </p>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">8. Limitation of Liability</h5>
          <p className="mt-2">
          Dartex role is limited to providing a technology platform and courier
            aggregation. Our liability is limited only to the extent of shipping charges
            collected.
          </p>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">9. Governing Law</h5>
          <p className="mt-2">
            These Terms are governed by and construed under the laws of India. Any disputes
            shall be subject to the exclusive jurisdiction of courts in{" "}
            <strong>New Delhi</strong>.
          </p>
        </section>

        <section className="mb-4">
          <h5 className="fw-semibold">10. Changes to Terms</h5>
          <p className="mt-2">
          Dartex may update these Terms & Conditions from time to time. Sellers will be
            notified through email or dashboard updates.
          </p>
        </section>

        <p className="text-muted mt-4">
          By registering with Dartex, you confirm that you have read, understood, and
          agreed to these <strong>Terms & Conditions</strong>.
        </p>
      </div>
    </div>
  )
}

export default Terms_conditions
